import { createFileRoute } from '@tanstack/react-router'
import { KBTMapAuthRedirect } from '../../../src/pages/KBT-Map/AuthRedirect'
import { kbtMapAuthRedirectSearchSchema } from '../../../src/schemas/routeSchemas'

export const Route = createFileRoute('/kbt-map/auth-redirect')({
  validateSearch: (search) => kbtMapAuthRedirectSearchSchema.parse(search),
  loaderDeps: ({ search }) => ({
    keyword: search.keyword,
    sg: search.sg,
    ts: search.ts,
    username: search.username,
  }),
  staticData: {
    englishAllowed: true,
  },
  component: KBTMapAuthRedirectComponent,
})

function KBTMapAuthRedirectComponent() {
  const search = Route.useSearch()

  return (
    <KBTMapAuthRedirect
      username={String(search.username)}
      ts={String(search.ts)}
      sg={String(search.sg)}
      keyword={search.keyword == null ? undefined : String(search.keyword)}
    />
  )
}
